import { render, staticRenderFns } from "./uploadAgenda.vue?vue&type=template&id=021e55ae&scoped=true&"
import script from "./uploadAgenda.vue?vue&type=script&lang=js&"
export * from "./uploadAgenda.vue?vue&type=script&lang=js&"
import style0 from "./uploadAgenda.vue?vue&type=style&index=0&id=021e55ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021e55ae",
  null
  
)

export default component.exports